import { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'

import { MenuButton, ChipPreRegistration } from 'components'
import { TableRow, TableCell } from 'components/Table'
import { RemoveLinkedDialog } from './components'

import constants from 'constants/index'
import helpers from 'helpers'

const LINK_STATUS_BADGE = {
  active: constants.preRegistration.LINK_ACTIVE_STATUS,
  churn: constants.preRegistration.CHURN_STATUS,
  unlinked: constants.preRegistration.UNLINKED_STATUS,
}

const PreRegistrationsTableRow = ({
  paymentContractPreRegistration,
  paymentContractId,
  refresh,
}) => {
  const [openModal, setOpenModal] = useState(false)

  const preRegistration = paymentContractPreRegistration?.preRegistration
  const linkStatus = paymentContractPreRegistration?.status
  const disabledBtn =
    ['churn', 'unlinked'].includes(linkStatus) ||
    paymentContractPreRegistration?.kind === 'owner'
  const handleOpenModal = () => setOpenModal(true)

  return (
    <>
      <TableRow key={preRegistration?.id}>
        <TableCell>{preRegistration?.id}</TableCell>
        <TableCell>{preRegistration?.name}</TableCell>
        <TableCell>
          {preRegistration?.kind === constants.companies.KINDS.PERSONAL
            ? helpers.formatters.cpf(preRegistration?.document)
            : helpers.formatters.cnpj(preRegistration?.document)}
        </TableCell>
        <TableCell>
          {
            constants.preRegistration.TYPE_CLIENT_LABEL[
              preRegistration?.typeClient
            ]
          }
        </TableCell>
        <TableCell align="left">
          {paymentContractPreRegistration?.kindLabel}
        </TableCell>
        <TableCell align="left">
          R${' '}
          {helpers.formatters.currencyInput(
            preRegistration?.priceRecommendation,
          )}
        </TableCell>
        <TableCell disableTooltip>
          <ChipPreRegistration status={preRegistration?.status} />
        </TableCell>
        <TableCell disableTooltip>
          <ChipPreRegistration status={LINK_STATUS_BADGE[linkStatus]} />
        </TableCell>
        <TableCell disableTooltip align="right">
          <MenuButton>
            <Button disabled={disabledBtn} onClick={handleOpenModal}>
              Excluir vinculo
            </Button>
          </MenuButton>
        </TableCell>
      </TableRow>
      {openModal && (
        <RemoveLinkedDialog
          open={openModal}
          paymentContractId={paymentContractId}
          preRegistrationId={preRegistration?.id}
          refresh={refresh}
          setOpen={setOpenModal}
        />
      )}
    </>
  )
}

PreRegistrationsTableRow.propTypes = {
  paymentContractPreRegistration: PropTypes.object,
  paymentContractId: PropTypes.number,
  refresh: PropTypes.func,
}

export default PreRegistrationsTableRow
